// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleList_container_2oc1v"};